import {
  theme as base,
  extendTheme,
  withDefaultVariant,
} from "@chakra-ui/react";

type ClientType = "OMNI" | "ALEC" | "APLEONA";

export const clientUrlParts: Record<ClientType, string[]> = {
  OMNI: ["omni-41", "omni2", "localhost", "bms","audit"],
  ALEC: ["alec"],
  APLEONA: ["apleona"],
};

export const ACCENT_COLORS: Record<ClientType, string> = {
  OMNI: "#FF7500",
  ALEC: "#a5192e",
  APLEONA: "#E73838",
};
export const INIT_COLOR_MODE: Record<ClientType, string> = {
  OMNI: "system",
  ALEC: "dark",
  APLEONA: "dark",
};

export function getClientByHostname(hostname: string): ClientType {
  let clientType: ClientType | undefined;

  Object.keys(clientUrlParts).forEach((key) => {
    if (
      clientUrlParts[key as ClientType].some((part) => hostname.includes(part))
    ) {
      clientType = key as ClientType;
    }
  });

  return clientType as ClientType;
}

export function getChakraTheme(hostname: string) {
  const clientType = getClientByHostname(hostname);
  const accentColor = ACCENT_COLORS[clientType];
  const initialColorMode = INIT_COLOR_MODE[clientType];

  return extendTheme(
    {
      initialColorMode,
      colors: {
        accentColor,
        darkBG: "#111E34",
        fieldBgLight: "#F8FAFC",
        fieldBgDark: "#040016",
        lightBorder: "#1B1B36",
        darkBorder: "#78789C",
      },
    },
    withDefaultVariant({
      variant: "filled",
      components: ["Input"],
    })
  );
}

const theme = extendTheme(
  {
    initialColorMode: "system",
    colors: {
      darkBG: "#111E34",
      fieldBgLight: "#F8FAFC",
      fieldBgDark: "#040016",
      lightBorder: "#1B1B36",
      darkBorder: "#78789C",
    },
    fonts: {
      heading: `Inter, ${base.fonts.heading}`,
      body: `Inter, ${base.fonts.body}`,
    },
  },
  withDefaultVariant({
    variant: "filled",
    components: ["Input"],
  })
);

export default theme;
